export const navbar = {
  Search: 'Buscar',
  Home: 'Inicio',
  'Your Library': 'Tu biblioteca',
  'Collapse your library': 'Collapsar tu biblioteca',
  'Expand your library': 'Expandir tu biblioteca',
  Language: 'Idioma',
  'Contact me': 'Contactame',
  'Source code': 'Código fuente',
  SearchPlaceholder: '¿Qué querés reproducir?',
  'Create a new Playlist': 'Crear una nueva Playlist',
  Playlists: 'Playlists',
  Artists: 'Artistas',
  Albums: 'Álbumes',
  'Playlist created': 'Playlist creada',
  COMPACT: 'Compacto',
  GRID: 'Grilla',
  LIST: 'Lista',
  'Log In': 'Iniciar sesión',
};
